import {platform} from 'substance'
import NewsMLSourceCommand from './newsmlsource/NewsMLSourceCommand'
import ConfigurationTestToolCommand from './configurationtesttool/ConfigurationTestToolCommand'
import ExperimentalCommand from './ExperimentalCommand'

const DevToolsPackage = {
    name: 'devtools',
    configure: function(configurator) {

        configurator.addCommand('NewsMLSourceCommand', NewsMLSourceCommand)
        configurator.addCommand('ConfigurationTestToolCommand', ConfigurationTestToolCommand)
        configurator.addCommand('ExperimentalCommand', ExperimentalCommand)

        if (platform.isMac) {
            configurator.addKeyboardShortcut('cmd+shift+u', {command: 'NewsMLSourceCommand'}, true, 'devtools-open-newsml-source')
            configurator.addKeyboardShortcut('cmd+shift+y', {command: 'ConfigurationTestToolCommand'}, true, 'devtools-open-configuration-test-tool')
            configurator.addKeyboardShortcut('cmd+shift+e', {command: 'ExperimentalCommand'}, true, 'devtools-experimental')
        }
        else {
            configurator.addKeyboardShortcut('ctrl+shift+u', {command: 'NewsMLSourceCommand'}, true, 'devtools-open-newsml-source')
            configurator.addKeyboardShortcut('ctrl+shift+y', {command: 'ConfigurationTestToolCommand'}, true, 'devtools-open-configuration-test-tool')
            configurator.addKeyboardShortcut('ctrl+shift+e', {command: 'ExperimentalCommand'}, true, 'devtools-experimental')
        }

        configurator.addLabel('ok', {
            en: 'Ok',
            sv: 'Ok'
        })

        configurator.addLabel('devtools-experimental', {
            en: 'Enable/disable experimental features',
            sv: 'Slå på/av experimentella features '
        })

        configurator.addLabel('devtools-open-newsml-source', {
            en: 'Open NewsML source',
            sv: 'Öppna NewsML-källa'
        })

        configurator.addLabel('devtools-open-configuration-test-tool', {
            en: 'Open configuration test tool',
            sv: 'Öppna konfigurationsverktyget'
        })

        configurator.addLabel('devtools-existing-tabs-description', {
            en: 'Existing tabs with tab ids, ordered.',
            sv: 'Befintliga flikar och tab-idn, sorterade.'
        })

        configurator.addLabel('Tab', {
            sv: 'Flik'
        })
    }
}

export {DevToolsPackage}
